package navigation.home.send_message

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.settings.domain.repository.ConfigurationRepository
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.client.domain.repository.ClientRepository
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.itinerary.domain.use_case.UpdateItineraryServiceUseCase
import com.essntl.features.itinerary.ui.send_message.SendMessageEvent
import com.essntl.features.itinerary.ui.send_message.SendMessageState
import com.essntl.features.itinerary.ui.send_message.SendMessageViewModel
import com.essntl.features.message.domain.useCase.CheckSendContactUseCase
import com.essntl.features.message.domain.useCase.SendItineraryMessageUseCase
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase

class SendMessageScreenModel(
    categoryRepository: CategoryRepository,
    itineraryRepository: ItineraryRepository,
    clientRepository: ClientRepository,
    configurationRepository: ConfigurationRepository,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    sendItineraryMessageUseCase: SendItineraryMessageUseCase,
    updateItineraryServiceUseCase: UpdateItineraryServiceUseCase,
    checkSendContactUseCase: CheckSendContactUseCase,
    loadingManager: LoadingManager,
) : StateScreenModel<SendMessageState>(SendMessageState()) {

    private val viewModel = SendMessageViewModel(
        categoryRepository = categoryRepository,
        itineraryRepository = itineraryRepository,
        clientRepository = clientRepository,
        configurationRepository = configurationRepository,
        getCurrentUserUseCase = getCurrentUserUseCase,
        sendItineraryMessageUseCase = sendItineraryMessageUseCase,
        updateItineraryServiceUseCase = updateItineraryServiceUseCase,
        checkSendContactUseCase = checkSendContactUseCase,
        state = mutableState,
        scope = screenModelScope,
        loadingManager = loadingManager,
    )

    fun onEvent(event: SendMessageEvent) = viewModel.onEvent(event)
}